import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const fetchValueDashboardForIndividualData = async (data: any) => {
	try {
		const { token, getMethod } = data || {};

		if (!token || !getMethod) {
			throw new Error('Invalid request payload');
		}

		const requestData = {
			fetchValueDashboardForIndividualDataToken: token,
		};
		let URL = '';

		switch (getMethod) {
			case 'GetAllActiveEmployees':
				URL = `${API_URL}GetAllActiveEmployees`;
				break;
			case 'GetAllActiveEmployeesforAll':
				URL = `${API_URL}GetAllActiveEmployeesforAll`;
				break;
			case 'GetAllTemporaryEmployees':
				URL = `${API_URL}GetAllTemporaryEmployees`;
				break;
			case 'GetAllTemporaryEmployeesforAll':
				URL = `${API_URL}GetAllTemporaryEmployeesforAll`;
				break;
			case 'GetAllAbesentEmployees':
				URL = `${API_URL}GetAllAbesentEmployees`;
				break;
			case 'GetAllAbesentEmployeesforAll':
				URL = `${API_URL}GetAllAbesentEmployeesforAll`;
				break;
			case 'CheckIn':
				URL = `${API_URL}GetAllCheckInMembers`;
				break;
			case 'CheckInforAll':
				URL = `${API_URL}GetAllCheckInMembersforAll`;
				break;
			case 'LateCheckin':
				URL = `${API_URL}GetAllLateCheckInMembers`;
				break;
			case 'LateCheckinforAll':
				URL = `${API_URL}GetAllLateCheckInMembersforAll`;
				break;
			case 'EarlyCheckout':
				URL = `${API_URL}GetAllEarlyCheckOutMembers`;
				break;
			case 'EarlyCheckoutforAll':
				URL = `${API_URL}GetAllEarlyCheckOutMembersforAll`;
				break;
			case 'OnLeave':
				URL = `${API_URL}GetAllOnLeaveMembers`;
				break;
			case 'OnLeaveforAll':
				URL = `${API_URL}GetAllOnLeaveMembersforAll`;
				break;
			case 'ResetMiskenlyEarlyCheckout':
				URL = `${API_URL}ResetMiskenlyEarlyCheckout`;
				break;
			case 'PendingLeaveRequests':
				URL = `${API_URL}GetPendingLeaveRequestsList`;
				break;
			case 'PendingLeaveRequestsforAll':
				URL = `${API_URL}GetPendingLeaveRequestsListForAll`;
				break;
			default:
				throw new Error('Invalid getMethod');
		}
		console.log('API URL:', URL);
		console.log('Request params:', { getMethod });
		return makeApiCall(URL, requestData);
	} catch (error) {
		console.error('API Error:', error);
		throw error;
	}
};
